import { useEffect, useState } from 'react';
import { clockNow } from '@/state/store';
export function usePassNow() {
  const [now, setNow] = useState(clockNow);
  useEffect(() => {
    const id = setInterval(() => setNow(clockNow()), 500);
    return () => clearInterval(id);
  }, []);
  return now;
}
